// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ToDoModal_ProjectFragmentDoc, ToDoModal_CohortFragmentDoc, ToDoModal_DevelopmentFragmentDoc, ToDoModal_MarketFragmentDoc } from '../../../../components/to-dos/ToDoModal.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ToDosPageDataQueryVariables = Types.Exact<{
  projectFilter: Types.ProjectFilter;
}>;


export type ToDosPageDataQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined } | { __typename?: 'Region', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined } | { __typename?: 'Market', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined } | { __typename?: 'Community', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined } | { __typename?: 'Subdivision', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined } | { __typename?: 'Lot', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined } | { __typename?: 'Structure', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined } | { __typename?: 'Unit', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined }>, cohorts: Array<{ __typename?: 'Cohort', id: string, name: string, development?: { __typename?: 'Development', id: string } | null | undefined }>, developments: Array<{ __typename?: 'Development', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }> };


export const ToDosPageDataDocument = gql`
    query ToDosPageData($projectFilter: ProjectFilter!) {
  projects(filter: $projectFilter) {
    ...ToDoModal_Project
  }
  cohorts {
    ...ToDoModal_Cohort
  }
  developments {
    ...ToDoModal_Development
  }
  markets {
    ...ToDoModal_Market
  }
  internalUsers {
    id
    name
    avatar
  }
}
    ${ToDoModal_ProjectFragmentDoc}
${ToDoModal_CohortFragmentDoc}
${ToDoModal_DevelopmentFragmentDoc}
${ToDoModal_MarketFragmentDoc}`;

/**
 * __useToDosPageDataQuery__
 *
 * To run a query within a React component, call `useToDosPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDosPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDosPageDataQuery({
 *   variables: {
 *      projectFilter: // value for 'projectFilter'
 *   },
 * });
 */
export function useToDosPageDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ToDosPageDataQuery, ToDosPageDataQueryVariables> & ({ variables: ToDosPageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ToDosPageDataQuery, ToDosPageDataQueryVariables>(ToDosPageDataDocument, options);
      }
export function useToDosPageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ToDosPageDataQuery, ToDosPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ToDosPageDataQuery, ToDosPageDataQueryVariables>(ToDosPageDataDocument, options);
        }
export function useToDosPageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDosPageDataQuery, ToDosPageDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ToDosPageDataQuery, ToDosPageDataQueryVariables>(ToDosPageDataDocument, options);
        }
export type ToDosPageDataQueryHookResult = ReturnType<typeof useToDosPageDataQuery>;
export type ToDosPageDataLazyQueryHookResult = ReturnType<typeof useToDosPageDataLazyQuery>;
export type ToDosPageDataSuspenseQueryHookResult = ReturnType<typeof useToDosPageDataSuspenseQuery>;
export type ToDosPageDataQueryResult = Apollo.QueryResult<ToDosPageDataQuery, ToDosPageDataQueryVariables>;